import { _ as _async_to_generator } from "@swc/helpers/_/_async_to_generator";
import { _ as _class_call_check } from "@swc/helpers/_/_class_call_check";
import { _ as _create_class } from "@swc/helpers/_/_create_class";
import { _ as _define_property } from "@swc/helpers/_/_define_property";
import { _ as _ts_decorate } from "@swc/helpers/_/_ts_decorate";
import { _ as _ts_generator } from "@swc/helpers/_/_ts_generator";
import { action, makeAutoObservable, observable, observe, runInAction } from "mobx";
import { format } from "intl-messageformat-tiny";
export var I18nVM = /*#__PURE__*/ function() {
    "use strict";
    function I18nVM() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        _class_call_check(this, I18nVM);
        _define_property(this, "loader", void 0);
        _define_property(this, "materials", {});
        _define_property(this, "default", undefined);
        _define_property(this, "current", undefined);
        _define_property(this, "supports", []);
        makeAutoObservable(this, {
            materials: observable.shallow
        }, {
            autoBind: true
        });
    }
    _create_class(I18nVM, [
        {
            /**
   * 语言翻译方法, 将对应的 `key` 翻译成明文文本
   *   `locale` 可缺省, 默认是当前语言
   * @param key
   * @param params
   * @param locale
   */ key: "t",
            value: function t(key, params, locale) {
                var _this_materials_this_current, _this_materials, _this_materials_this_current1, _this_materials1, _this_materials_this_default, _this_materials2;
                if (((_this_materials = this.materials) === null || _this_materials === void 0 ? void 0 : (_this_materials_this_current = _this_materials[this.current]) === null || _this_materials_this_current === void 0 ? void 0 : _this_materials_this_current[key]) === undefined) {
                    var _this_materials_this_default1, _this_materials3;
                    console.error("语言库[".concat(this.current, "], 没有找到: '").concat(key, "'"));
                    if (!((_this_materials3 = this.materials) === null || _this_materials3 === void 0 ? void 0 : (_this_materials_this_default1 = _this_materials3[this.default]) === null || _this_materials_this_default1 === void 0 ? void 0 : _this_materials_this_default1[key]) === undefined) {
                        console.error("语言库[".concat(this.default, "], 没有找到: '").concat(key, "'"));
                    }
                }
                var _this_materials_this_current_key, _ref;
                return format((_ref = (_this_materials_this_current_key = (_this_materials1 = this.materials) === null || _this_materials1 === void 0 ? void 0 : (_this_materials_this_current1 = _this_materials1[this.current]) === null || _this_materials_this_current1 === void 0 ? void 0 : _this_materials_this_current1[key]) !== null && _this_materials_this_current_key !== void 0 ? _this_materials_this_current_key : (_this_materials2 = this.materials) === null || _this_materials2 === void 0 ? void 0 : (_this_materials_this_default = _this_materials2[this.default]) === null || _this_materials_this_default === void 0 ? void 0 : _this_materials_this_default[key]) !== null && _ref !== void 0 ? _ref : key, params, locale);
            }
        },
        {
            key: "setLocaleMaterials",
            value: /**
   * 批量设置语言包
   * @param materials
   */ function setLocaleMaterials(materials) {
                var _this = this;
                Object.keys(materials).forEach(function(locale) {
                    return _this.setLocaleMaterial(locale, materials[locale]);
                });
            }
        },
        {
            key: "setLocaleMaterial",
            value: /**
   * 设置一个语言的语言包
   * @param locale
   * @param material
   */ function setLocaleMaterial(locale, material) {
                this.materials[locale] = Object.assign({}, this.materials[locale], material);
            }
        },
        {
            /**
   * 获取所有的语言包
   */ key: "getLocaleMaterials",
            value: function getLocaleMaterials() {
                return this.materials;
            }
        },
        {
            /**
   * 获取当前语言的语言包
   * @param locale
   */ key: "getLocaleMaterial",
            value: function getLocaleMaterial(locale) {
                var _ref;
                return this.materials[(_ref = locale !== null && locale !== void 0 ? locale : this.current) !== null && _ref !== void 0 ? _ref : this.default];
            }
        },
        {
            /**
   * 获取当前被启用的语言
   */ key: "getLocale",
            value: function getLocale() {
                var _this_current;
                return (_this_current = this.current) !== null && _this_current !== void 0 ? _this_current : this.default;
            }
        },
        {
            key: "setLocale",
            value: /**
   * 启用语言
   * @param locale
   */ function setLocale(locale) {
                var _this = this;
                return _async_to_generator(function() {
                    var material;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!_this.loader) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    _this.loader(locale)
                                ];
                            case 1:
                                material = _state.sent();
                                runInAction(function() {
                                    _this.setLocaleMaterial(locale, material);
                                    _this.current = locale;
                                });
                                return [
                                    2
                                ];
                            case 2:
                                _this.current = locale;
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            /**
   * 设置默认语言
   * @param locale
   */ key: "setDefault",
            value: function setDefault(locale) {
                this.current = locale;
            }
        },
        {
            /**
   * 设置当前支持的语言的包列表
   * @param supports
   */ key: "setSupports",
            value: function setSupports(supports) {
                this.supports = supports;
            }
        },
        {
            /**
   * 批量配置API
   * @param options
   */ key: "config",
            value: function config(options) {
                if (options.supports) this.setSupports(options.supports || []);
                if (options.default) this.setDefault(options.default);
                if (options.current) this.setLocale(options.current);
                if (options.materials) this.setLocaleMaterials(options.materials || {});
                if (options.loader) this.loader = options.loader;
            }
        },
        {
            key: "$observe",
            value: function $observe(key, listener, invokeImmediately) {
                return observe(this, key, listener, invokeImmediately);
            }
        }
    ]);
    return I18nVM;
}();
_ts_decorate([
    action.bound
], I18nVM.prototype, "setLocaleMaterials", null);
_ts_decorate([
    action.bound
], I18nVM.prototype, "setLocaleMaterial", null);
